import React, { useCallback, useState } from 'react'
import message from 'antd/lib/message'
import { apiManager } from 'helpers'

import { CloseIcon, PrimaryButton } from 'components'
import Modal from 'components/AuthModal/components/Modal'
import Overlay from 'components/AuthModal/components/Overlay'
import Input from 'components/AuthModal/components/Input'
import { OVERLAY } from 'components/AuthModal/styles'

const FreeTicketModal = ({ show, onClose, eventId }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [userId, setUserId] = useState()

  const handleChange = ({ target: { value } }) => setUserId(value)

  const handleSubmit = useCallback(
    async e => {
      e.preventDefault()

      message.loading('submitting...', 0)
      setIsSubmitting(true)

      try {
        await apiManager.addUserToEvent(eventId, userId)
        setUserId(undefined)
        message.destroy()
        message.success('User added to event successfully', 2.5)
        onClose(true)
      } catch (error) {
        message.destroy()
        message.error(error.message || 'Please try again')
      } finally {
        setIsSubmitting(false)
      }
    },
    [userId, eventId, onClose]
  )

  return (
    <Overlay show={show} className={OVERLAY} preventEscBackdropClose={true} onClose={onClose}>
      <Modal innerClassName="bg-white rounded-t-3xl overflow-y-scroll md:rounded-xl">
        <div className="relative w-full p-5 md:p-7 md:py-5 md:w-108">
          <button className="bg-transparent absolute top-3 right-4" onClick={onClose}>
            <CloseIcon className="w-3 h-3" />
          </button>
          <div className="text-center text-xl font-bold font-ownersWide mb-4">Give Free Ticket</div>
          <form onSubmit={handleSubmit}>
            <Input
              type="number"
              name="userId"
              value={userId}
              label="User ID"
              required
              classNames={{ input: 'py-2 mt-1 text-center' }}
              styles={{
                input: {
                  color: '#222',
                },
              }}
              onChange={handleChange}
            />
            <div className="flex justify-center mt-8">
              <PrimaryButton
                disabled={!userId}
                type="submit"
                loading={isSubmitting}
                className="text-base h-10"
              >
                Submit
              </PrimaryButton>
            </div>
          </form>
        </div>
      </Modal>
    </Overlay>
  )
}

export default FreeTicketModal
